import ormaApi from './OrmaApi';

export const loadPageViewsApi = async (memberId, yearMonth) => {
  try {
    const response = await ormaApi.post(
      '/api/pageviews/updateAndFetchMyPageViewsForMember',
      {
        memberId,
        yearMonth,
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error loading page views:', error);
    throw error;
  }
};

export const updatePageViewsApi = async (memberId, url, start, end, yearMonth) => {
  try {
    const response = await ormaApi.post('/api/pageviews/updatePageViews', {
      memberId,
      url,
      start,
      end,
      yearMonth,
    });
    return response.data;
  } catch (error) {
    console.error('Error updating page views:', error);
    throw error;
  }
};

export const pushPageViewsApi = async (memberId, pageViewData) => {
  try {
    const response = await ormaApi.post('/api/pageviews/createManualPageView', {
      memberId,
      url: pageViewData.url,
      start: pageViewData.pvStart,
      end: pageViewData.pvEnd,
      desc: pageViewData.desc,
      yearMonth: pageViewData.ymRef,
    });
    return response.data;
  } catch (error) {
    console.error('Error creating page view:', error);
    throw error;
  }
};

export const editPageViewsApi = async (memberId, start, exclude, yearMonth) => {
  try {
    const response = await ormaApi.post('/api/pageviews/setPageViewExclusion', {
      memberId,
      start,
      exclude,
      yearMonth,
    });
    return response.data;
  } catch (error) {
    console.error('Error editing page view exclusion:', error);
    throw error;
  }
};
